module.exports = __webpack_public_path__ + "img/phone.1fba7873.svg";